export default __webpack_public_path__ + "static/media/20.a44d7a28.png";